var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconFilesPublicDomainLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconFilesPublicDomain",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M960 0c529.355 0 960 430.645 960 960s-430.645 960-960 960S0 1489.355 0 960 430.645 0 960 0Zm0 112.941c-467.125 0-847.059 379.934-847.059 847.059 0 467.125 379.934 847.059 847.059 847.059 467.125 0 847.059-379.934 847.059-847.059 0-467.125-379.934-847.059-847.059-847.059ZM800.157 711C913.347 711 970 762.572 970 865.418c0 17.658-2.726 34.752-8.177 50.905-5.45 16.153-14.907 32.355-28.312 48.563-13.405 16.152-33.513 29.48-60.35 39.756-26.782 10.22-58.57 15.6-95.31 15.6H687.2V1167H571V711ZM686 797v138h99.1c23.94 0 41.9-6.51 53.911-19.733C851.021 902.043 857 885.923 857 866.283c0-46.114-24.944-68.845-74.86-68.845h-95.753L686 797Zm496.205-86c73.564 0 131.301 18.77 173.154 55.976C1397.101 804.182 1418 861.64 1418 938.978c0 77.421-20.899 134.908-62.64 172.059-41.854 37.206-99.563 55.963-173.155 55.963h-179.171l-.034-.279V711ZM1118 806l.185.027V1072h66.635c40.731 0 70.258-12.192 88.635-36.362 18.35-24.115 27.545-56.367 27.545-96.706 0-40.34-9.155-72.619-27.505-96.762-18.35-24.057-48.338-36.087-90.043-36.087L1118 806Z",
        stroke: "#979797",
        fillRule: "evenodd"
      }))
    });
  }
}
IconFilesPublicDomainLine.glyphName = 'files-public-domain';
IconFilesPublicDomainLine.variant = 'Line';
IconFilesPublicDomainLine.displayName = 'IconFilesPublicDomainLine';
IconFilesPublicDomainLine.allowedProps = [...SVGIcon.allowedProps];
export default IconFilesPublicDomainLine;
export { IconFilesPublicDomainLine };